import Vue from 'vue';
import axios from 'axios';
import { NODE_ENV } from '../.env.js';


const sendToSlack = text => {
  axios.post('https://hooks.slack.com/services/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', {
    channel: '#bug-report',
    username: 'CareYes FrontEnd',
    headers: { 'Content-Type': 'application/json' },
    text
  })
    .then(() => {})
    .catch(() => {});
};

if (NODE_ENV === 'production') {
  Vue.config.errorHandler = err => {
    sendToSlack(err);
  };

  window.addEventListener('error', promiseRejectionEvent => {
    sendToSlack(promiseRejectionEvent.reason.stack);
  });

  window.onerror = function (message, file, line, col, error) {
    sendToSlack(`Error occurred: ${error.message}`);
    return false;
  };

  window.addEventListener('error', e => {
    sendToSlack(`Error occurred: ${e.error.message}`);
    return false;
  });
}
